import { render } from "./InfoModal.vue?vue&type=template&id=8efa7766&scoped=true"
import script from "./InfoModal.vue?vue&type=script&lang=js"
export * from "./InfoModal.vue?vue&type=script&lang=js"

import "./InfoModal.vue?vue&type=style&index=0&id=8efa7766&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8efa7766"]])

export default __exports__